// extracted by mini-css-extract-plugin
export var subtitle = "Title-module--subtitle--OMAYc";
export var title = "Title-module--title--Dncfh";